import { defineStore } from 'pinia';
import { ref } from 'vue';

/** Whether Cmd+K is open. The strip's Search button and Home's search box open it too. */
export const useCommandPaletteStore = defineStore('commandPalette', () => {
    const isOpen = ref(false);
    const open = () => {
        isOpen.value = true;
    };
    const close = () => {
        isOpen.value = false;
    };
    const toggle = () => {
        isOpen.value = !isOpen.value;
    };
    return { isOpen, open, close, toggle };
});
